export default status => {
  if (status === 'SUCCEEDED') {
    return '#ececff';
  } if (status === 'FAILED') {
    return '#ffe0b1';
  } return '#e2e2e2';
};
